<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h6 class="modal-title d-flex align-items-center gap-2">
        <ng-container i18n>Push Rates & Availability</ng-container>
        <app-page-help articleId="hCaQ7PhF23UVnKijCJ2iDS" videoId="vME7vbq4DE0"></app-page-help>
      </h6>
      <div class="d-flex gap-3">
        <div class="btn-group dropdown" role="group" dropdown [isDisabled]="1 | isReadonlyRole">
          <button dropdownToggle type="button" class="btn btn-secondary-warning dropdown-toggle">
            <span class="cs-icon cs-icon-bolt"></span> <ng-container i18n>Actions</ng-container>
          </button>
          <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
            <li>
              <button (click)="table?.onPushRate()" type="button">
                <span class="fas fa-arrow-up"></span>
                <ng-container i18n>Pushed Mapped Rates</ng-container>
              </button>
            </li>
            <li>
              <button (click)="table?.onPushAvailability()" type="button">
                <span class="far fa-calendar-alt"></span>
                <ng-container i18n>Push Availability</ng-container>
              </button>
            </li>
            <li>
              <button (click)="table?.onDisableAutoSync()" type="button">
                <span class="far fa-pause"></span>
                <ng-container i18n>Disable Auto Sync</ng-container>
              </button>
            </li>
            <li>
              <button (click)="table?.onEnableAutoSync()" type="button">
                <span class="far fa-play"></span>
                <ng-container i18n>Enable Auto Sync</ng-container>
              </button>
            </li>
            <!--            <li>-->
            <!--              <button (click)="table?.onSetFrequency('daily')" type="button" [disabled]="!table?.isAnySelected()">-->
            <!--                <span class="far fa-calendar-day"></span>-->
            <!--                <ng-container i18n>Set Sync Daily</ng-container>-->
            <!--              </button>-->
            <!--            </li>-->
            <!--            <li>-->
            <!--              <button (click)="table?.onSetFrequency('weekly')" type="button" [disabled]="!table?.isAnySelected()">-->
            <!--                <span class="far fa-calendar-week"></span>-->
            <!--                <ng-container i18n>Set Sync Weekly</ng-container>-->
            <!--              </button>-->
            <!--            </li>-->
          </ul>
        </div>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="container-box">
        <app-channel-rate-mappings-table #table></app-channel-rate-mappings-table>
      </div>
    </div>
  </div>
</div>
